export const IMAGE_LOADED = "IMAGE_LOADED";
